module.exports = __webpack_public_path__ + "images/6-i_old35c29d892b7db300d58ddd70d1334273.svg";